var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.containerClass,attrs:{"id":"app"}},[_c('HeaderMenu'),_c('router-view'),(this.$route.name != 'Cart')?_c('Footer'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }